import { Routes } from '@angular/router'
import { authGuard } from './guards/auth.guard'
import { superAdminGuard } from './guards/super-admin.guard'

const TITLE_BASE = 'Home To Home Animal Adoption'

export const routes: Routes = [
  {
    path: 'about',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `About - ${TITLE_BASE}`,
  },
  {
    path: 'accessibility',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Accessibility Statement - ${TITLE_BASE}`,
  },
  {
    path: 'admin',
    canActivate: [authGuard, superAdminGuard],
    loadChildren: () =>
      import('./pages/admin/routes').then((m) => m.ADMIN_ROUTES),
    title: `Admin - ${TITLE_BASE}`,
  },
  {
    path: 'superadmin',
    canActivate: [authGuard, superAdminGuard],
    loadChildren: () =>
      import('./pages/superadmin/routes').then((m) => m.SUPERADMIN_ROUTES),
    title: `Super Admin - ${TITLE_BASE}`,
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account/routes').then((m) => m.ACCOUNT_ROUTES),
    title: `Account - ${TITLE_BASE}`,
    canActivate: [authGuard],
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./pages/blog/routes').then((m) => m.BLOG_ROUTES),
    title: `Blog - ${TITLE_BASE}`,
  },
  {
    path: 'boost',
    loadComponent: () =>
      import('./boost/boost.component').then((m) => m.BoostComponent),
    title: `Boost Pet - ${TITLE_BASE}`,
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./pages/contact/routes').then((m) => m.CONTACT_ROUTES),
    title: `Contact - ${TITLE_BASE}`,
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq.page').then((m) => m.FaqPage),
    title: `FAQ - ${TITLE_BASE}`,
  },
  {
    path: 'contract/:id',
    loadComponent: () =>
      import('./pages/contract/contract.page').then((m) => m.ContractPage),
    title: `Contract - ${TITLE_BASE}`,
    canActivate: [authGuard],
  },
  { path: 'findpet', redirectTo: 'find-pet', pathMatch: 'full' },
  {
    path: 'find-pet',
    loadComponent: () =>
      import('./pages/pets/find-pet/find-pet.page').then((m) => m.FindPetPage),
    title: `Find Pet - ${TITLE_BASE}`,
  },
  {
    path: 'wp-json/shelter_pets/v1/:slug',
    loadComponent: () =>
      import('./pages/shelter-iframe/shelter-iframe.page').then(
        (m) => m.ShelterIFramePage,
      ),
    title: `Find Pet - ${TITLE_BASE}`,
  },
  {
    path: 'wp-json/shelter_pets/uuid/:uuid',
    loadComponent: () =>
      import('./pages/shelter-iframe/shelter-iframe.page').then(
        (m) => m.ShelterIFramePage,
      ),
    title: `Find Pet - ${TITLE_BASE}`,
  },
  {
    path: 'wp-json/shelter_pets/zipcode/:zipcode',
    loadComponent: () =>
      import('./pages/shelter-iframe/shelter-iframe.page').then(
        (m) => m.ShelterIFramePage,
      ),
    title: `Find Pet - ${TITLE_BASE}`,
  },
  {
    path: 'how-it-works',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `How It Works - ${TITLE_BASE}`,
  },
  {
    path: 'join-as-shelter',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Join as Shelter - ${TITLE_BASE}`,
  },
  {
    path: 'our-sponsor',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Our Sponsor - ${TITLE_BASE}`,
  },
  {
    path: 'adopting',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Adopting on Home To Home - ${TITLE_BASE}`,
  },
  {
    path: 'pets',
    loadChildren: () =>
      import('./pages/pets/pet-detail/routes').then((m) => m.PET_ROUTES),
    title: `Pets - ${TITLE_BASE}`,
  },
  {
    path: 'messages',
    loadChildren: () =>
      import('./pages/messages/routes').then((m) => m.MESSAGE_ROUTES),
    title: `Message - ${TITLE_BASE}`,
    canActivate: [authGuard],
  },
  {
    path: 'messages',
    outlet: 'modal',
    loadChildren: () =>
      import('./pages/messages/routes').then((m) => m.MESSAGE_MODAL_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Privacy Policy - ${TITLE_BASE}`,
  },
  {
    path: 'cookie-settings',
    loadComponent: () =>
      import('./components/cookie-settings/cookie-settings.component').then(
        (m) => m.CookieSettingsComponent,
      ),
    title: `Cookie Settings - ${TITLE_BASE}`,
  },
  {
    path: 'rehome',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Rehome - ${TITLE_BASE}`,
  },
  {
    path: 'resources',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Resources - ${TITLE_BASE}`,
  },
  {
    path: 'shelters',
    loadChildren: () =>
      import('./pages/shelters/routes').then((m) => m.SHELTER_ROUTES),
  },
  {
    path: 'sponsors',
    loadComponent: () =>
      import('./pages/sponsors/sponsors.page').then((m) => m.SponsorsPage),
    title: `Sponsors & Partners - ${TITLE_BASE}`,
  },
  {
    path: 'shelter',
    loadChildren: () =>
      import('./pages/shelters/routes').then((m) => m.SHELTER_ROUTES),
  },
  {
    path: 'story',
    loadChildren: () =>
      import('./pages/success-story/routes').then(
        (m) => m.SUCCESS_STORY_ROUTES,
      ),
    title: `Stories - ${TITLE_BASE}`,
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Terms of Use - ${TITLE_BASE}`,
  },
  {
    path: 'training',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Shelter Training - ${TITLE_BASE}`,
  },
  {
    path: 'verify',
    loadComponent: () => import('./pages/cms/cms.page').then((m) => m.CmsPage),
    title: `Verify - ${TITLE_BASE}`,
  },
  {
    path: 'auth',
    outlet: 'modal',
    loadChildren: () => import('./auth/routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'donate',
    outlet: 'modal',
    loadChildren: () =>
      import('./pages/donation/routes').then((m) => m.DONATION_ROUTES),
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
    title: `Home - ${TITLE_BASE}`,
  },
  {
    path: 'fostering',
    loadComponent: () =>
      import('./pages/fostering/fostering.page').then((m) => m.FosteringPage),
    title: `Fostering - ${TITLE_BASE}`,
  },
  {
    path: 'packages/:id',
    loadComponent: () =>
      import('./pages/packages/packages.page').then((m) => m.PackagesPage),
    title: `Packages - ${TITLE_BASE}`,
    canActivate: [authGuard],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.page').then((m) => m.NotFoundPage),
  },
]
